import { aboutInfo } from '@/mocks/about';

export default function TestimonialsSection() {
  return (
    <section className="w-full py-14 md:py-18 px-4 md:px-6 bg-background-100">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
            用户口碑
          </h2>
          <p className="text-foreground-500 text-sm mt-2">
            来自真实用户和行业专家的评价
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {aboutInfo.testimonials.map((t) => (
            <div
              key={t.name}
              className="bg-background-50 rounded-lg p-6 border border-background-200/70"
            >
              <div className="flex items-center gap-2 mb-3">
                <i className="ri-double-quotes-l text-2xl text-primary-400"></i>
              </div>
              <p className="text-foreground-600 text-sm leading-relaxed">{t.content}</p>
              <div className="mt-4 pt-3 border-t border-background-200/60">
                <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
                <p className="text-xs text-foreground-400">{t.role}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}